import React from "react";
import { Box } from "@mui/material";
import Logo from "../../../assets/Images/LogoLogin1.png";
import SantePlusText from "../../../assets/Images/LogoLogin2.png";
import BlueBar from "../../../assets/Images/LogoLogin3.png";
import MedicalCenterText from "../../../assets/Images/LogoLogin4.png";

const LogoHeader = () => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <Box
      component="img"
      src={Logo}
      alt="Logo SantéPlus"
      sx={{ width: 80, height: "auto", mb: 2 }}
    />
    <Box
      component="img"
      src={SantePlusText}
      alt="SantéPlus"
      sx={{ width: 180, height: "auto", mb: 1 }}
    />
    <Box
      component="img"
      src={BlueBar}
      alt=""
      sx={{ width: "80%", height: "auto", mb: 1 }}
    />
    <Box
      component="img"
      src={MedicalCenterText}
      alt="Medical Center"
      sx={{ width: 150, height: "auto", mb: 3 }}
    />
  </Box>
);

export default LogoHeader;
